import request from '@/utils/request'

// 联系我们反馈提交
export function addFeedback(data) {
    return request({
        url: '/gtwg/pc/addFeedback',
        method: 'post',
        data
    })
}
// 联系我们
export function getContactUs() {
    return request({
        url: '/gtwg/pc/contactUs',
        method: 'get'
    })
}